/**
 * Credit Card Payment Monitoring Script (Desktop)
 * Logs payment-related events for diagnostics using console.warn for visibility
 */

(function() {
    'use strict';

    const PAYMENT_MONITOR_PREFIX = '[PaymentMonitoring:CreditCard] ';

    function logPaymentEvent(eventType, details) {
        const message = PAYMENT_MONITOR_PREFIX + eventType + ' | ' + JSON.stringify(details);
        console.warn(message);
    }

    function logPaymentMethodChange(method, details) {
        logPaymentEvent('PAYMENT_METHOD_CHANGED', {
            paymentMethod: method,
            ...details
        });
    }

    window.creditCardPaymentMonitoring = {
        logPaymentEvent,
        logPaymentMethodChange
    };

})();

var lastSelectedCreditCardType;

var MODULE = (function (library, $) {

    $(function () {
        $(".j-cmbCreditCardTypes").on('change', function (e) {
            if (lastSelectedCreditCardType) {
                $(".j-" + lastSelectedCreditCardType + "-image").hide();
            }
            $(".j-" + $(this).val() + "-image").show();
            lastSelectedCreditCardType = $(this).val();
        });
    });
    return library;
})(MODULE || {}, jQuery);

$(document).ready(function () {
    var paymentMethod = $(".j-cmbCreditCardTypes").val();

    if (paymentMethod !== '' ) {
        $(".j-" + paymentMethod + "-image").show();
    }
    lastSelectedCreditCardType = paymentMethod;
});